import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@toman/ui-kit-light";
import { emptyTransactionsSvg } from "../assets/images";

const ErrorPage: React.FC<{ error?: string }> = ({ error }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-background-surface gap-8">
      <img
        draggable={false}
        src={emptyTransactionsSvg}
        alt="Error"
        className="w-[180px] h-[180px]"
      />
      <span className="text-md-semi-bold text-text-danger">خطایی رخ داده است</span>
      <span className="text-sm-regular text-text-secondary text-center">
        {error || "متاسفانه مشکلی پیش آمده است. لطفا دوباره تلاش کنید یا بعدا مراجعه کنید."}
      </span>
      <Button variant="filled" className="mt-4" onClick={() => navigate("/")}>
        بازگشت به صفحه اصلی
      </Button>
    </div>
  );
};

export default ErrorPage;
